/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Button, Icon } from 'sarsaparilla';

export default function ExpandMainViewButton({
    onClick,
    isExpanded,
}: {
    onClick: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
    isExpanded: boolean;
}) {
    const toggleButtonText = isExpanded ? 'Collapse Table' : 'Expand Table';
    const toggleButtonIcon = isExpanded ? (
        <Icon iconName="contract" />
    ) : (
        <Icon iconName="expand" />
    );
    const buttonScreenReaderText = (action: string) => `- ${action} the Trip Itinerary`;
    const toggleButtonScreenReaderText = isExpanded
        ? buttonScreenReaderText('View')
        : buttonScreenReaderText('Hide');
    return (
        <Button
            appearance="link"
            size="sm"
            className="toggle-button"
            title="Toggle Expand Table"
            onClick={onClick}
            iconBeforeElement={toggleButtonIcon}
            screenReaderTextAfter={toggleButtonScreenReaderText}
        >
            {toggleButtonText}
        </Button>
    );
}
